(() => {
class $90df0591fe51bcf3$export$2e2bcd8739ae039 {
    /**
	 *
	 * @type {Array<{element: HTMLElement, module: Object}>}
	 */ #holders = [];
    /**
	 *
	 * @param {Array<Object>} modules
	 */ constructor(modules){
        for (const module of modules)this.#holders = this.#holders.concat(module.getHolderSelectors().flatMap((selector)=>[
                ...document.querySelectorAll(selector)
            ]).map((holder)=>Object.create({
                element: holder,
                module: module
            })));
        document.addEventListener("dependency-chain:loaded", this.#createReadyModules.bind(this));
        this.#createReadyModules();
    }
    #createReadyModules() {
        for (const holder of this.#holders)if (holder.element.dataset.module === "ready") {
            new holder.module(holder.element);
            holder.element.dataset.module = "created";
        }
    }
}


class $817ed0efc43d2bf4$export$2e2bcd8739ae039 {
    static getHolderSelectors = ()=>[
            ".event-links"
        ];
    /** @type {HTMLElement} */ #holderElement;
    /** @param {HTMLElement} holderElement */ constructor(holderElement){
        this.#holderElement = holderElement;
        this.#logoHover();
    }
    #logoHover() {
        const logoHover = this.#holderElement.querySelector(".logo-hover");
        const gradientHover = logoHover.querySelector(".gradient-hover");
        let updatePosition = true;
        logoHover.addEventListener("mousemove", (event)=>{
            if (updatePosition) {
                updatePosition = false;
                gradientHover.style.background = `radial-gradient(circle at ${event.offsetX}px ${event.offsetY}px, rgba(0,0,0,0) 0%, rgba(0,0,0,.98) 400px)`;
                window.setTimeout(()=>updatePosition = true, 50);
            }
        });
    }
}


class $dff1855d0af00f68$export$2e2bcd8739ae039 {
    static getHolderSelectors = ()=>[
            ".speakers-slider"
        ];
    /** @type {HTMLElement} */ #holderElement;
    /** @param {HTMLElement} holderElement */ constructor(holderElement){
        this.#holderElement = holderElement;
        this.#holderElement.querySelector(".splide");
        const slider = new Splide(this.#holderElement.querySelector(".splide"), {
            arrows: false,
            fixedWidth: "31rem",
            focus: "center",
            gap: "2.12rem",
            type: "loop",
            pagination: false,
            breakpoints: {
                576: {
                    fixedWidth: "calc(100vw - 2rem)"
                }
            }
        });
        slider.mount();
        this.#holderElement.querySelectorAll("[data-slider-control]").forEach((button)=>{
            button.addEventListener("click", ()=>{
                slider.go(button.dataset.sliderControl);
            });
        });
    }
}


class $b71605b2411f416e$export$2e2bcd8739ae039 {
    static getHolderSelectors = ()=>[
            ".video-modal-btn"
        ];
    constructor(videoModalButton){
        const modal = document.querySelector(videoModalButton.dataset.bsTarget);
        const video = new Vimeo.Player(modal.querySelector("iframe"));
        modal.addEventListener("hidden.bs.modal", ()=>{
            video.pause();
        });
    }
}


class $b89db87ccaf9b090$export$2e2bcd8739ae039 {
    static getHolderSelectors = ()=>[
            "header.header"
        ];
    /** @type {HTMLElement} */ #holderElement;
    /** @type {HTMLElement} */ #mainMenu;
    /** @type {int} */ #initialMainMenuHeight;
    /** @param {HTMLElement} holderElement */ constructor(holderElement){
        this.#holderElement = holderElement;
        this.#mainMenu = this.#holderElement.querySelector(".main-menu");
        this.#initialMainMenuHeight = this.#mainMenu.offsetHeight;
        const navMenu = this.#holderElement.querySelector(".nav-menu");
        const ticketsMenu = this.#holderElement.querySelector(".tickets-menu");
        const navButton = this.#holderElement.querySelector(".nav-menu-button");
        const ticketsButton = this.#holderElement.querySelector(".tickets-menu-button");
        this.#mainMenu.style.height = this.#initialMainMenuHeight + "px";
        navButton.addEventListener("click", ()=>{
            ticketsButton.classList.remove("open");
            ticketsMenu.classList.remove("open");
            this.#toggleMenu(navMenu);
        });
        ticketsButton.addEventListener("click", ()=>{
            ticketsButton.classList.toggle("open");
            navMenu.classList.remove("open");
            this.#toggleMenu(ticketsMenu);
        });
        document.addEventListener("click", (event)=>{
            if (!event.composedPath().includes(this.#mainMenu)) {
                navMenu.classList.remove("open");
                ticketsMenu.classList.remove("open");
                this.#mainMenu.style.height = this.#initialMainMenuHeight + "px";
            }
        });
        let scrolled = false;
        let ticking = false;
        document.addEventListener("scroll", (event)=>{
            if (!ticking) {
                window.requestAnimationFrame(()=>{
                    if (window.scrollY > 100 && !scrolled) {
                        scrolled = true;
                        this.#holderElement.classList.add("scrolled");
                    } else if (window.scrollY <= 100 && scrolled) {
                        scrolled = false;
                        this.#holderElement.classList.remove("scrolled");
                    }
                    ticking = false;
                });
                ticking = true;
            }
        });
        let resizeTick = false;
        window.addEventListener("resize", ()=>{
            if (!resizeTick) window.requestAnimationFrame(()=>{
                this.#mainMenu.style.height = null;
                this.#initialMainMenuHeight = this.#mainMenu.offsetHeight;
                this.#mainMenu.style.height = this.#initialMainMenuHeight + "px";
                resizeTick = false;
            });
            resizeTick = true;
        });
    }
    /**
	 *
	 * @param {HTMLElement} menu
	 */ #toggleMenu(menu) {
        if (menu.classList.contains("open")) {
            menu.classList.remove("open");
            this.#mainMenu.style.height = this.#initialMainMenuHeight + "px";
        } else {
            window.setTimeout(()=>menu.classList.add("open"), 100);
            this.#mainMenu.style.height = this.#initialMainMenuHeight + menu.offsetHeight + "px";
        }
    }
}


class $35037d5a6ca955b8$export$2e2bcd8739ae039 {
    static getHolderSelectors = ()=>[
            "section.agenda"
        ];
    /** @type {HTMLElement} */ #holderElement;
    /** @param {HTMLElement} holderElement */ constructor(holderElement){
        this.#holderElement = holderElement;
        const sliderElement = this.#holderElement.querySelector(".splide");
        const slider = new Splide(sliderElement, {
            arrows: false,
            pagination: false
        });
        slider.mount();
        const controls = document.querySelectorAll("[data-slider-control]");
        controls.forEach((button)=>{
            button.addEventListener("click", ()=>{
                const index = Number.parseInt(button.dataset.sliderControl);
                slider.go(Number.isNaN(index) ? button.dataset.sliderControl : index);
                sliderElement.scrollIntoView({
                    behavior: "smooth"
                });
                controls.forEach((c)=>c.classList.remove("active"));
                if (!Number.isNaN(index)) document.querySelectorAll(`header [data-slider-control="${index}"]`).forEach((b)=>b.classList.add("active"));
            });
        });
        const defaultDayIndex = parseInt(sliderElement.dataset.defaultDay);
        if (defaultDayIndex > 0) {
            slider.go(defaultDayIndex);
            controls.forEach((c)=>c.classList.remove("active"));
            document.querySelectorAll(`header [data-slider-control="${defaultDayIndex}"]`).forEach((b)=>b.classList.add("active"));
        }
    }
}


class $96f115d591b71cc9$export$2e2bcd8739ae039 {
    static getHolderSelectors = ()=>[
            "section.hero-video"
        ];
    /**
	 * @param holderElement
	 */ constructor(holderElement){
        const video = holderElement.querySelector("video");
        if (video && Hls.isSupported()) {
            const hls = new Hls();
            hls.loadSource(video.dataset.videoUrl);
            hls.attachMedia(video);
            video.play();
        } else if (video && video.canPlayType("application/vnd.apple.mpegurl")) {
            video.src = video.dataset.videoUrl;
            video.play();
        } else if (video) console.warn("HLS is not supported for this browser");
    }
}


class $705b29208695696f$export$2e2bcd8739ae039 {
    static getHolderSelectors = ()=>[
            "section.conferences-slider"
        ];
    /** @param {HTMLElement} holderElement */ constructor(holderElement){
        const slider = new Splide(holderElement.querySelector(".splide"), {
            arrows: false,
            fixedWidth: "27rem",
            fixedHeight: "28rem",
            focus: "center",
            gap: "2.12rem",
            type: "loop",
            drag: false,
            pagination: false
        });
        slider.mount();
        const sliderArrows = holderElement.querySelectorAll("[data-slider-control]");
        sliderArrows.forEach((arrow)=>{
            arrow.addEventListener("click", ()=>{
                slider.go(arrow.dataset.sliderControl);
            });
        });
        let modalSlider = null;
        const galleryModal = document.querySelector(".gallery-modal");
        document.querySelectorAll(".gallery-modal-toggle").forEach((button)=>{
            button.addEventListener("click", ()=>{
                galleryModal.classList.toggle("open");
                const selector = `[data-conference="${button.dataset.conference}"]`;
                if (modalSlider) modalSlider.destroy();
                galleryModal.querySelectorAll("[data-conference]").forEach((slider)=>{
                    if (slider.dataset.conference !== button.dataset.conference) slider.classList.add("d-none");
                    else slider.classList.remove("d-none");
                });
                modalSlider = new Splide(galleryModal.querySelector(selector), {
                    fixedWidth: "100vw",
                    pagination: false,
                    arrows: false,
                    type: "loop"
                }).mount();
            });
        });
        galleryModal.querySelectorAll("[data-slider-control]").forEach((sliderControl)=>{
            sliderControl.addEventListener("click", ()=>{
                if (modalSlider) modalSlider.go(sliderControl.dataset.sliderControl);
            });
        });
    }
}


class $bfeb5cc5128ab69f$export$2e2bcd8739ae039 {
    static getHolderSelectors = ()=>[
            "section.gallery"
        ];
    /**
	 * @param {HTMLElement} holderElement
	 */ constructor(holderElement){
        new LuminousGallery(holderElement.querySelectorAll(".luminous-image"));
    }
}


const $f588187e97d40c34$var$modules = [
    (0, $35037d5a6ca955b8$export$2e2bcd8739ae039),
    (0, $705b29208695696f$export$2e2bcd8739ae039),
    (0, $817ed0efc43d2bf4$export$2e2bcd8739ae039),
    (0, $b89db87ccaf9b090$export$2e2bcd8739ae039),
    (0, $dff1855d0af00f68$export$2e2bcd8739ae039),
    (0, $b71605b2411f416e$export$2e2bcd8739ae039),
    (0, $96f115d591b71cc9$export$2e2bcd8739ae039),
    (0, $bfeb5cc5128ab69f$export$2e2bcd8739ae039)
];
new (0, $90df0591fe51bcf3$export$2e2bcd8739ae039)($f588187e97d40c34$var$modules);

})();
//# sourceMappingURL=main.js.map
